import React from 'react';
import PasswordChecklist from './passwordChecklist';

const ValidatePasswordCreation = (props) => {
  const {
    password,
    repeatPassword,
    onPasswordIsValid,
    language
  } = props;

  const handlePasswordIsValid = (isValid, failedRules) => {
    onPasswordIsValid(isValid);
  }

  return (
    <PasswordChecklist
      className="password-checklist__content mt-1"
      rules={["minLength", "specialChar", "number", "lowercase", "capital", "match"]}
      minLength={8}
      value={password}
      valueAgain={repeatPassword}
      onChange={handlePasswordIsValid}
      iconSize={10}
      validColor="#41c99f"
      invalidColor="#dc3522"
      messages={{
        minLength: language.account.accountUser.passwordChecklist.minLength,
        specialChar: language.account.accountUser.passwordChecklist.specialChar,
        number: language.account.accountUser.passwordChecklist.number,
        capital: language.account.accountUser.passwordChecklist.capital,
        lowercase: language.account.accountUser.passwordChecklist.lowercase,
        match: language.account.accountUser.passwordChecklist.match,
      }}
    />
  )
}

export default ValidatePasswordCreation;


// WEBPACK FOOTER //
// ./source/client/components/common/validatePasswordCreation.jsx